import styles from "./Spinner.module.css";

export interface SpinnerProps {
  small?: boolean;
}

export default function Spinner({ small }: SpinnerProps) {
  const size = small ? 14 : 20;
  return (
    <svg
      className={styles.spinner}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle r="10" cx="12" cy="12" strokeDasharray="42.8 20" />
      62.80
    </svg>
  );
}
